<div class="header_area">
  <div class="container-fluid p-0">
    <nav id="navigation1" class="navigation">
      <div class="nav-header">
        <div class="nav-toggle"></div>
      </div>

      <div class="nav-menus-wrapper">
        <div class="nav-header">
          <div class="nav-toggle" id="nav-toggle"><i class="fa fa-bars fa-lg"></i></div>
        </div>
        <div id="sideMenu-header" class="sideMenu-header">
          <a href="/home">
            <img class="sideMenu-logo" [src]="configService.getLogo('BA_LOGO_MOBILE')" />
          </a>
        </div>
        <div class="addedforflex container" style="display: flex" *ngIf="!disableMenu">
          <ul class="nav-menu" *ngFor="let tab of menu.tabs">
            <li [hidden]="!userLoggedIn && tab.title === 'My Account'">
              <a (click)="closeNav()" routerLink="{{ tab.url }}" routerLinkActive="active" ariaCurrentWhenActive="page">{{ tab.title }}</a>

              <div class="megamenu-panel" *ngIf="tab.megamenu === 'true'">
                <div class="megamenu-lists container">
                  <ul>
                    <div *ngFor="let category of categoryMap.get(tab.title)" class="megamenu-list list-col-4">
                      <li class="tabTitle">
                        <a (click)="closeNav(); navigateToLink(category.url, category.title)" *ngIf="category.url !== ''" routerLinkActive="active" ariaCurrentWhenActive="page" style="cursor: pointer;">{{ category.title }}</a>
                        <a (click)="closeNav()" *ngIf="category.url === '' && category.title !== ''" style="text-decoration: none" ariaCurrentWhenActive="page">{{ category.title }}</a>
                      </li>
                      <div *ngFor="let link of linkMap.get(category.title)">
                        <li *ngIf="link.url.includes('https://')">
                          <a (click)="closeNav()" href="{{ link.url }}" ariaCurrentWhenActive="page">{{ link.title }} </a>
                        </li>

                        <li *ngIf="!link.url.includes('https://')">
                          <a (click)="closeNav(); navigateToLink(link.url, link.title)" routerLinkActive="active" ariaCurrentWhenActive="page" style="cursor: pointer;">{{ link.title }} </a>
                        </li>
                      </div>
                    </div>
                  </ul>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </div>
</div>
